export function RefundPolicy() {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Refund Policy</h1>
        <p className="legal-updated">Last updated: February 23, 2026</p>

        <div className="legal-content">
          <h2>1. General Policy</h2>
          <p>
            <strong>
              All subscription payments to CryptoGuardians are final and non-refundable, except
              where required by applicable law.
            </strong>{' '}
            By subscribing to CryptoGuardians, you acknowledge and agree that subscription fees
            are charged for access to the platform and are earned upon payment.
          </p>

          <h2>2. Subscription Billing</h2>
          <p>
            Paid plans are billed on a recurring monthly basis via{' '}
            <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">
              Stripe, Inc.
            </a>{' '}
            Your subscription automatically renews unless cancelled before the next billing date.
          </p>

          <h2>3. Cancellation</h2>
          <p>
            You may cancel your subscription at any time. Cancellation takes effect at the end of
            your current billing period. Upon cancellation:
          </p>
          <ul>
            <li>You retain access to paid features until the end of the current billing period</li>
            <li>No further charges will be applied after the current period ends</li>
            <li>
              <strong>
                Cancellation does not entitle you to a refund of the current or any prior
                billing period
              </strong>
            </li>
          </ul>

          <h2>4. Exceptions</h2>
          <p>
            Refunds may be considered at the sole discretion of HAJ Solutions, Inc. in the
            following limited circumstances:
          </p>
          <ul>
            <li>
              <strong>Duplicate charges:</strong> If you were charged more than once for the same
              billing period due to a technical error
            </li>
            <li>
              <strong>Legal requirement:</strong> Where a refund is required by applicable consumer
              protection laws in your jurisdiction
            </li>
          </ul>
          <p>
            To request a refund under these exceptions, contact us at{' '}
            <a href="mailto:billing@cryptoguardians.io">billing@cryptoguardians.io</a>{' '}
            within 14 calendar days of the charge. Include the wallet address associated with your
            subscription, the date of the charge, and a description of the issue.
          </p>

          <h2>5. Non-Refundable Situations</h2>
          <p>
            <strong>Refunds will not be issued for:</strong>
          </p>
          <ul>
            <li>Change of mind or dissatisfaction with the service</li>
            <li>Failure to cancel before a renewal date</li>
            <li>Partial use or non-use of the service during a billing period</li>
            <li>
              Losses incurred from cryptocurrency transactions, regardless of whether
              CryptoGuardians analysis was used
            </li>
            <li>Service interruptions or downtime</li>
            <li>Changes to features or functionality</li>
            <li>Accounts terminated for violation of our Terms of Service</li>
          </ul>

          <h2>6. Chargebacks</h2>
          <p>
            <strong>
              Initiating a chargeback or payment dispute without first contacting our support team
              is a violation of these terms.
            </strong>{' '}
            Unauthorized chargebacks may result in:
          </p>
          <ul>
            <li>Immediate and permanent suspension of your account</li>
            <li>Denial of future access to CryptoGuardians services</li>
            <li>
              Pursuit of the disputed amount through appropriate legal and payment processor
              channels
            </li>
          </ul>
          <p>
            We reserve the right to dispute all fraudulent or unauthorized chargebacks. If you
            believe a charge is incorrect, please contact{' '}
            <a href="mailto:billing@cryptoguardians.io">billing@cryptoguardians.io</a>{' '}
            before initiating a dispute with your financial institution.
          </p>

          <h2>7. Refund Method</h2>
          <p>
            If a refund is approved under the exceptions described in Section 4, it will be
            credited to the original payment method used at the time of purchase. Processing
            times depend on your financial institution and typically take 5&ndash;10 business
            days.
          </p>

          <h2>8. Changes to This Policy</h2>
          <p>
            We reserve the right to modify this Refund Policy at any time. Changes will be posted
            on this page with an updated effective date. Continued use of CryptoGuardians after
            changes constitutes acceptance of the revised policy.
          </p>

          <h2>9. Contact</h2>
          <p>
            Questions about this Refund Policy? Contact us:
          </p>
          <ul>
            <li>
              Billing: <a href="mailto:billing@cryptoguardians.io">billing@cryptoguardians.io</a>
            </li>
            <li>
              Support: <a href="/support">Support page</a>
            </li>
          </ul>

          <p className="legal-updated" style={{ marginTop: '3rem', borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem' }}>
            CryptoGuardians is a product of HAJ Solutions Inc.
          </p>
        </div>
      </div>
    </div>
  );
}
